import { Pipe, PipeTransform } from '@angular/core';
import { single } from 'rxjs';
import { SelectOption } from '../models/option';

@Pipe({
  name: 'toName',
  standalone: true,
})
export class ToNamePipe implements PipeTransform {
  transform(
    value: string,
    options: SelectOption[],
    plural: PluralEnum = PluralEnum.single
  ): string {
    for (let option of options) {
      if (option.id == value) {
        return plural == PluralEnum.plural
          ? option.namePlural
            ? option.namePlural
            : ''
          : option.name;
      }
    }
    return value;
  }
}
export enum PluralEnum {
  single,
  plural,
}
